/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface VideoContentHospitalCategoryThumbnailPath {
  /** 병원 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 병원ID */
  hospitalID?: string;
  /** 운동 콘텐츠 ID */
  vcID?: string;
  /** 병원 운동콘텐츠 생성 순서를 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 운동 콘텐츠 제목 */
  title?: string;
  /** 운동 콘텐츠 부제목 */
  subtitle?: string;
  /** 운동 콘텐츠 카테고리 */
  categories?: VideoContentCategory[];
  /** 병원 운동콘텐츠 카테고리 이름 */
  categoryName?: string[];
  /** 미사용 - 운동 태그 */
  exerciseTag?: string[];
  /** 미사용 - 운동 난이도(레벨) */
  difficulty?: number;
  /** 병원 운동콘텐츠 검색키워드 */
  searchKeyword?: string;
  /** 운동 종류 */
  exerciseType?: string;
  /** 자극부위 */
  stimulateMuscles?: string;
  /** 자극부위 이미지 ID */
  stimulateMusclesImageID?: string;
  /** 운동 정보 */
  description?: string;
  /** 관련 질환 */
  relatedDiseases?: string;
  /** 운동 구성 */
  exerciseSet?: VideoContentExerciseSet[];
  /** 준비물. */
  material?: VideoContentMaterial[];
  /** 주의사항 */
  precaution?: string;
  /** 미사용 - 기본 일주일 중 실천 횟수 */
  default_DoPerWeek?: number;
  /** 미사용 - 기본 처방기간 */
  default_Duration?: number;
  /** 미사용 - 기본 운동콘텐츠 코멘트 */
  default_Message?: string;
  /**
   * 일주일 중 실천할 횟수(주 n회), 기본값 주 3회
   * @default 3
   */
  doPerWeek?: number;
  /**
   * 처방기간 (n주 동안 진행), 기본값 2주
   * @default 2
   */
  duration?: number;
  /** 미사용 - 처방 문구 */
  message?: string;
  /** 영상 썸네일 FileID */
  thumbnailFileID?: FilePaths;
  /** 영상 FileID */
  videoFileID?: string;
  /**
   * 운동 콘텐츠 중 세부동작에 해당하는지 여부
   * @default false
   */
  isDetail?: boolean;
  /**
   * 숨김 처리 여부
   * @default false
   */
  isHidden?: boolean;
  /**
   * 운동콘텐츠 삭제 여부
   * @default false
   */
  isRemoved?: boolean;
  /** 자동 발송에 사용할 운동 콘텐츠인지 여부 */
  isDefault?: boolean;
  /**
   * 적합 태그 라벨링용 boolean값
   * @default false
   */
  isRecommend?: boolean;
  /** 영상 전체길이 (단위 ms) */
  totalVideoLength?: number;
  /** 처방 횟수(병원-커스텀 기준) */
  sendCount?: number;
  /** 시청 횟수(병원-커스텀 기준) */
  viewCount?: number;
  /** 총 부분 시청 횟수 */
  partViewCount?: number;
  /** 이행 완료 횟수 (병원-커스텀 기준) */
  completeViewCount?: number;
  /** 공유 횟수(병원-커스텀 기준) */
  shareCount?: number;
  /** 예약 횟수 (병원-커스텀 기준, 게스트 유저가 전화예약 버튼을 누른 횟수) */
  guestReservationCount?: number;
  /** 병원-운동콘텐츠에 대한 평균이행률(단위  % 퍼센트. 소수점 첫째 자리에서 반올림 하여 저장) */
  avgCompletionRate?: number;
  /** 기본영상이 2개 이상인 경우, 발송 순서 */
  defaultOrder?: number;
  /**
   * 생성일
   * @format date-time
   */
  createdAt?: string;
  /**
   * 마지막 수정일
   * @format date-time
   */
  updatedAt?: string;
}

export interface VideoContentCategory {
  /** 홈케어 콘텐츠 카테고리 고유ID */
  _id?: string;
  /** 운동콘텐츠 카테고리명 */
  categoryName?: string;
  /** 병원ID */
  hospitalID?: string;
  /** 정렬순서 */
  sortNum?: number;
  /** 상위 카테고리 ID. */
  parentCategoryIDs?: string[];
  /** 카테고리 대 여부 */
  isTop?: boolean;
  /** 카테고리 중 여부 */
  isParent?: boolean;
  /** 숨김 처리 여부 */
  isHidden?: boolean;
  /** 카테고리별 기초 콘텐츠 여부 */
  isBasic?: boolean;
  /** 운동콘텐츠 카테고리에 대한 설명 (oo의원 전용 콘텐츠 등) */
  description?: string;
  /** 카테고리의 명칭 (부위, 난이도, ...) */
  typeName?: string;
  /** 컨디셔닝 영상 여부 */
  isConditioning?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface VideoContentExerciseSet {
  /** 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 운동구성 내 운동 제목 */
  title?: string;
  /** 운동구성 내 운동 제목(영문) */
  titleEn?: string;
  /** 운동구성 내 운동 설명 */
  description?: number;
  /** 운동구성 내 썸네일 파일 ID */
  thumbnailFileID?: string;
  /** 운동구성 내 운동 시간(ms) */
  timestamp?: number;
}

export interface VideoContentMaterial {
  /** 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 준비물명 */
  name?: string;
  /** 운동구성 내 썸네일 파일 ID */
  thumbnailFileID?: string;
}

export interface FilePaths {
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths?: string[];
}

export interface VideoContentHospitalThumbnails {
  /** 병원 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 병원ID */
  hospitalID?: string;
  /** 운동 콘텐츠 ID */
  vcID?: string;
  /** 병원 운동콘텐츠 생성 순서를 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 운동 콘텐츠 제목 */
  title?: string;
  /** 운동 콘텐츠 부제목 */
  subtitle?: string;
  /** 운동 콘텐츠 카테고리 */
  categories?: VideoContentCategory[];
  /** 병원 운동콘텐츠 카테고리 이름 */
  categoryName?: string[];
  /** 미사용 - 운동 태그 */
  exerciseTag?: string[];
  /** 미사용 - 운동 난이도(레벨) */
  difficulty?: number;
  /** 병원 운동콘텐츠 검색키워드 */
  searchKeyword?: string;
  /** 운동 종류 */
  exerciseType?: string;
  /** 자극부위 */
  stimulateMuscles?: string;
  /** 자극부위 이미지 ID */
  stimulateMusclesImageID?: FilePaths;
  /** 운동 정보 */
  description?: string;
  /** 관련 질환 */
  relatedDiseases?: string;
  /** 운동 구성 */
  exerciseSet?: VideoContentExerciseSetFilePaths[];
  /** 준비물. */
  material?: VideoContentMaterialFilePaths[];
  /** 주의사항 */
  precaution?: string;
  /** 미사용 - 기본 일주일 중 실천 횟수 */
  default_DoPerWeek?: number;
  /** 미사용 - 기본 처방기간 */
  default_Duration?: number;
  /** 미사용 - 기본 운동콘텐츠 코멘트 */
  default_Message?: string;
  /**
   * 일주일 중 실천할 횟수(주 n회), 기본값 주 3회
   * @default 3
   */
  doPerWeek?: number;
  /**
   * 처방기간 (n주 동안 진행), 기본값 2주
   * @default 2
   */
  duration?: number;
  /** 미사용 - 처방 문구 */
  message?: string;
  /** 영상 썸네일 FileID */
  thumbnailFileID?: FilePaths;
  /** 영상 FileID */
  videoFileID?: string;
  /**
   * 운동 콘텐츠 중 세부동작에 해당하는지 여부
   * @default false
   */
  isDetail?: boolean;
  /**
   * 숨김 처리 여부
   * @default false
   */
  isHidden?: boolean;
  /**
   * 운동콘텐츠 삭제 여부
   * @default false
   */
  isRemoved?: boolean;
  /** 자동 발송에 사용할 운동 콘텐츠인지 여부 */
  isDefault?: boolean;
  /**
   * 적합 태그 라벨링용 boolean값
   * @default false
   */
  isRecommend?: boolean;
  /** 영상 전체길이 (단위 ms) */
  totalVideoLength?: number;
  /** 처방 횟수(병원-커스텀 기준) */
  sendCount?: number;
  /** 시청 횟수(병원-커스텀 기준) */
  viewCount?: number;
  /** 총 부분 시청 횟수 */
  partViewCount?: number;
  /** 이행 완료 횟수 (병원-커스텀 기준) */
  completeViewCount?: number;
  /** 공유 횟수(병원-커스텀 기준) */
  shareCount?: number;
  /** 예약 횟수 (병원-커스텀 기준, 게스트 유저가 전화예약 버튼을 누른 횟수) */
  guestReservationCount?: number;
  /** 병원-운동콘텐츠에 대한 평균이행률(단위  % 퍼센트. 소수점 첫째 자리에서 반올림 하여 저장) */
  avgCompletionRate?: number;
  /** 기본영상이 2개 이상인 경우, 발송 순서 */
  defaultOrder?: number;
  /**
   * 생성일
   * @format date-time
   */
  createdAt?: string;
  /**
   * 마지막 수정일
   * @format date-time
   */
  updatedAt?: string;
}

export interface VideoContentExerciseSetFilePaths {
  /** 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 운동구성 내 운동 제목 */
  title?: string;
  /** 운동구성 내 운동 제목(영문) */
  titleEn?: string;
  /** 운동구성 내 운동 설명 */
  description?: number;
  /** 운동구성 내 썸네일 파일 ID */
  thumbnailFileID?: FilePaths;
  /** 운동구성 내 운동 시간(ms) */
  timestamp?: number;
}

export interface VideoContentMaterialFilePaths {
  /** 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 준비물명 */
  name?: string;
  /** 운동구성 내 썸네일 파일 ID */
  thumbnailFileID?: FilePaths;
}

export interface ApiVideocontenthospitalElFindParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /** 검색할 단어 (홈케어 콘텐츠 제목, 검색키워드) */
  keyword?: string;
  /** 세부동작 영상 표시 여부 boolean flag */
  isDetail?: boolean;
  /** 검색할 홈케어 콘텐츠 카테고리ID */
  categoryID?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiVideocontenthospitalElFindData = ApiResponse & {
  data: VideoContentHospitalCategoryThumbnailPath[];
};

export interface ApiVideocontenthospitalElDetailParams {
  /** (required) 병원 홈케어 콘텐츠의 ObjectID */
  vchID: string;
}

export type ApiVideocontenthospitalElDetailData = ApiResponse & {
  data: VideoContentHospitalThumbnails;
};

export interface ApiVideocontenthospitalElPlayParams {
  /** VideoContentHospital ID */
  vchID: string;
  /** (미사용) 인트로 영상 사용 여부 */
  usingIntro?: string;
}

export type ApiVideocontenthospitalElPlayData = any;

export interface ApiVideocontenthospitalElPlaysubParams {
  /** videoFileID */
  _id?: string;
  usingIntro?: string;
  resolution?: string;
}

export type ApiVideocontenthospitalElPlaysubData = any;

export interface ApiVideocontenthospitalHmDetailParams {
  /** (required) 병원 홈케어 콘텐츠의 ObjectID */
  vchID: string;
}

export type ApiVideocontenthospitalHmDetailData = ApiResponse & {
  data: VideoContentHospitalThumbnails;
};

export interface ApiVideocontenthospitalHmPlayParams {
  /** VideoContentHospital ID */
  vchID: string;
  /** (미사용) 인트로 영상 사용 여부 */
  usingIntro?: string;
}

export type ApiVideocontenthospitalHmPlayData = any;

export interface ApiVideocontenthospitalHmPlaysubParams {
  /** videoFileID */
  _id?: string;
  usingIntro?: string;
  resolution?: string;
}

export type ApiVideocontenthospitalHmPlaysubData = any;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 검색어가 일치하는 홈케어 콘텐츠 표기. 기본 정렬 순서 없음.
     *
     * @tags V3-VideoContentHospital
     * @name ApiVideocontenthospitalElFind
     * @summary 병원 홈케어 콘텐츠 조회 및 검색
     * @request GET:/v3/api/videocontenthospital/el/find
     * @secure
     * @response `200` `ApiVideocontenthospitalElFindData` \[\{VideoContentHospital\}\] 병원 홈케어 콘텐츠 컬렉션 객체 배열
     */
    apiVideocontenthospitalElFind: (query: ApiVideocontenthospitalElFindParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalElFindData, any>({
        path: `/v3/api/videocontenthospital/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-VideoContentHospital
     * @name ApiVideocontenthospitalElDetail
     * @summary 병원 홈케어 콘텐츠 상세 조회
     * @request GET:/v3/api/videocontenthospital/el/detail
     * @secure
     * @response `200` `ApiVideocontenthospitalElDetailData` \{VideoContentHospital\} 병원 홈케어 콘텐츠 컬렉션 객체
     */
    apiVideocontenthospitalElDetail: (query: ApiVideocontenthospitalElDetailParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalElDetailData, any>({
        path: `/v3/api/videocontenthospital/el/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-VideoContentHospital
     * @name ApiVideocontenthospitalElPlay
     * @summary VideoContentHospital 내 vchID의 재생 URL
     * @request GET:/v3/api/videocontenthospital/el/play
     * @secure
     * @response `200` `ApiVideocontenthospitalElPlayData` list of m3u8 file
     */
    apiVideocontenthospitalElPlay: (query: ApiVideocontenthospitalElPlayParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalElPlayData, any>({
        path: `/v3/api/videocontenthospital/el/play`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-VideoContentHospital
     * @name ApiVideocontenthospitalElPlaysub
     * @summary VideoContentHospital 내 videoFileID의 Detail 재생 URL
     * @request GET:/v3/api/videocontenthospital/el/playsub
     * @secure
     * @response `200` `ApiVideocontenthospitalElPlaysubData` detail list of m3u8 file
     */
    apiVideocontenthospitalElPlaysub: (query: ApiVideocontenthospitalElPlaysubParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalElPlaysubData, any>({
        path: `/v3/api/videocontenthospital/el/playsub`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-VideoContentHospital
     * @name ApiVideocontenthospitalHmDetail
     * @summary 병원 상담 모바일 앱 - 병원 홈케어 콘텐츠 상세 조회
     * @request GET:/v3/api/videocontenthospital/hm/detail
     * @secure
     * @response `200` `ApiVideocontenthospitalHmDetailData` \{VideoContentHospital\} 병원 홈케어 콘텐츠 컬렉션 객체
     */
    apiVideocontenthospitalHmDetail: (query: ApiVideocontenthospitalHmDetailParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalHmDetailData, any>({
        path: `/v3/api/videocontenthospital/hm/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-VideoContentHospital
     * @name ApiVideocontenthospitalHmPlay
     * @summary 병원 상담 모바일 앱 - VideoContentHospital 내 vchID의 재생 URL
     * @request GET:/v3/api/videocontenthospital/hm/play
     * @secure
     * @response `200` `ApiVideocontenthospitalHmPlayData` list of m3u8 file
     */
    apiVideocontenthospitalHmPlay: (query: ApiVideocontenthospitalHmPlayParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalHmPlayData, any>({
        path: `/v3/api/videocontenthospital/hm/play`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-VideoContentHospital
     * @name ApiVideocontenthospitalHmPlaysub
     * @summary 병원 상담 모바일 앱 - VideoContentHospital 내 videoFileID의 Detail 재생 URL
     * @request GET:/v3/api/videocontenthospital/hm/playsub
     * @secure
     * @response `200` `ApiVideocontenthospitalHmPlaysubData` detail list of m3u8 file
     */
    apiVideocontenthospitalHmPlaysub: (query: ApiVideocontenthospitalHmPlaysubParams, params: RequestParams = {}) =>
      this.request<ApiVideocontenthospitalHmPlaysubData, any>({
        path: `/v3/api/videocontenthospital/hm/playsub`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
}
